// This is just an example,
// so you can safely delete all default props below

export default {
    title: 'Min konto',
    profile: 'Min profil',
    orders: 'Mine bestillinger',
    change_password: 'Bytt passord',
    delete_account: 'Slett konto'
}
